import * as React from 'react'
function SvgAnnounce(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31.725 7.75l-24.5 7C6.525 15.1 6 15.8 6 16.5v7c0 .7.525 1.4 1.225 1.75l2.275.525v6.475c0 1.05.7 1.75 1.75 1.75H20c1.05 0 1.75-.7 1.75-1.75v-2.975l9.975 2.8c1.05.35 2.275-.525 2.275-1.75V9.5c0-1.225-1.05-1.925-2.275-1.75zM18.25 30.5H13v-3.675l5.25 1.575v2.1z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgAnnounce
